'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';

const noAdRoutes = [
  '/bihar/school-maps',
  '/bihar/magic-match',
  '/ghackk-admin',
  '/dashboard',
  '/checkout',
  '/membership',
];

export default function SiteAutoAds() {
  const pathname = usePathname();
  if (noAdRoutes.some((route) => pathname.startsWith(route))) return null;

  return (
    <Script
      id="adsense-auto"
      async
      src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2160642618089124"
      crossOrigin="anonymous"
      strategy="afterInteractive"
    />
  );
}
